import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarContext } from '../../context/SidebarContext';
import AdminSidebar from '../adminsettings/AdminSidebar';
import SidebarComponent from '../sidebar/SidebarComponent';

const DynamicSidebar = () => {
  const { setIsAdminSettingsPage, setIsExportDomainPage } = useContext(SidebarContext);
  const location = useLocation();

  useEffect(() => {
    setIsAdminSettingsPage(location.pathname === '/admin-settings');
    setIsExportDomainPage(location.pathname === '/export-domain');
  }, [location.pathname, setIsAdminSettingsPage, setIsExportDomainPage]);

  return (
    <>
      {location.pathname === '/admin-settings' || location.pathname === '/export-domain' 
        ? <AdminSidebar /> 
        : <SidebarComponent />}
    </>
  );
};

export default DynamicSidebar;
